import { createImageUrl } from '@nrk/serum-imagecrop-utils'

function createSrcSet({ id, widths, ratio }) {
  try {
    return widths
      .map((width, idx) => {
        const imageUrl = createImageUrl({
          id,
          width,
          ratio,
          quality: 0.8
        })
        return `${imageUrl} ${width}w`
      })
      .join(', ')
  } catch (err) {
    return ''
  }
}

export { createImageUrl, createSrcSet }
